// extracted by mini-css-extract-plugin
export default {"backdrop":"style_backdrop__gAEcx"};